import { render, staticRenderFns } from "./EditorialBoardCard.vue?vue&type=template&id=14e536a8&scoped=true"
import script from "./EditorialBoardCard.vue?vue&type=script&lang=js"
export * from "./EditorialBoardCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e536a8",
  null
  
)

export default component.exports